<template>
  <div class="table-wrapper">
    <el-table
      :data="data"
      stripe
      style="width: 100%"
      size="medium"
      header-row-class-name="common-table-header"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      :border="false"
    >
      <el-table-column prop="orderNo" label="续费单号" width="180"></el-table-column>
      <el-table-column prop="renewalTime" label="续费时间" width="180"></el-table-column>
      <el-table-column prop="optUserName" label="操作人">
        <template #default="{ row: { optUserName, accountNo } }">
          {{ optUserNameShowContent(optUserName, accountNo) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template #default="{ row: { id } }">
          <span style="color: #1e8dff" @click="viewOrderDetail(id)">查看</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrapper">
      <el-pagination
        class="is-print-hide common-el-pagination"
        layout="prev, pager, next, total, jumper, sizes"
        :total="total"
        :current-page="pageNo"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        @current-change="val => $emit('handle-pageNo', val)"
        @size-change="val => $emit('handle-pageSize', val)"
      />
      <div class="sureJump global_common_button_goast">确定</div>
    </div>
  </div>
</template>

<script>
import { optUserNameShowContent } from '@/util';
export default {
  name: 'renewalOrderTable',
  props: {
    data: {
      type: Array
    },
    total: {
      type: Number
    },
    pageNo: {
      type: Number
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array
    }
  },
  data() {
    return {};
  },
  methods: {
    optUserNameShowContent,
    viewOrderDetail(id) {
      this.$emit('handle-viewOrderDetail', id);
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  color: #1e8dff;
  font-size: 12px;
  cursor: pointer;

  & + .btn {
    margin-left: 5px;
  }
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;

  /deep/.el-pagination {
    margin-top: 0;
  }

  .sureJump {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    width: 80px;
    height: 32px;
    border-radius: 3px;
    cursor: pointer;
  }
}
.expire-warning {
  color: #df3933;
}
</style>
